var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80106 16.4726L18.2317 3.19833C18.4974 2.93389 18.9404 2.93389 19.2061 3.19833L20.8007 4.78531C21.0664 5.04975 21.0664 5.4906 20.8007 5.75503L5.68164 20.8017C5.41593 21.0661 5.00244 21.0661 4.73674 20.8017L3.17695 19C2.94072 18.7649 2.94072 18.3241 3.17695 18.0596L4.80106 16.4726Z",
    fill: "#E33232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52736 4.80106L20.8017 18.2317C21.0661 18.4974 21.0661 18.9404 20.8017 19.2061L19.2147 20.8007C18.9502 21.0664 18.5094 21.0664 18.245 20.8007L3.19833 5.68164C2.93389 5.41593 2.93389 5.00244 3.19833 4.73674L5 3.17695C5.2351 2.94072 5.67595 2.94072 5.94038 3.17695L7.52736 4.80106Z",
    fill: "#E33232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.10772c2b2453c1eb8a503621c27d1a7f.svg";
export { ForwardRef as ReactComponent };